import {Component, Optional} from '@angular/core';
import {AppContainerOptions, BackdropContainerEnum, ISwUpdateOptions, SwUpdateService, UserMenuItemsEnum} from '@mydocma/app-container';
import {UntilDestroy} from "@ngneat/until-destroy";
import {ConfigProvider} from '@mydocma/common';
import { firstValueFrom } from 'rxjs';
import { BackdropService } from '@mydocma/component-library/src/lib/backdrop';
import { JfConfig } from 'projects/mydocma/jf/src/lib/jf-config/jf-config.interface';
import package_json from '../../../package.json';

@UntilDestroy()
@Component({
    selector: 'app-main',
    templateUrl: './main.component.html',
    styleUrls: ['./main.component.scss']
})
export class MainComponent {
    public version: string = package_json.version;

    constructor(
        @Optional() public options: AppContainerOptions,
        private configService: ConfigProvider<JfConfig>,
        private readonly updateService: SwUpdateService,
        private backDropService: BackdropService
    ) {
        this.setInitialAppContainerOptions();
        this.updateService.attachBeforeSwUpdateCallback(this.beforeUpdate.bind(this));
    }

    private setInitialAppContainerOptions(): void {
        if (!this.options) return;

        this.options.appIcon.name = this.configService.getConfigData().appName;
        this.options.appIcon.color = this.configService.getConfigData().appIconColor;
        this.options.header.userMenuItems.version = package_json.version;
        
        this.options.sideNavBar.isVisible = false;
        this.options.header.customerSelection = false;
        this.options.header.projectSelection = false;
        this.options.header.userMenuItems.shouldShowLogs = false;
        this.options.header.userMenuItems.shouldShowConnectivity = false;
        this.options.disableCustomerProjectBlockingLoader = true;
        
        const userSettingsItem = this.options.header.userMenuItems.items?.find(value => value.id === UserMenuItemsEnum.userSettings);
        if (userSettingsItem) userSettingsItem.hidden = true;
    }

    private async beforeUpdate(): Promise<ISwUpdateOptions> {
        let canUpdate = true;

        const backDrops = await firstValueFrom(this.backDropService.activeBackdrops$);
        if (backDrops) canUpdate = backDrops.find(bd=> bd.options?.name === BackdropContainerEnum.MydocmaAppHeader) ? false : true;

        return {
            allowUpdate: canUpdate,
            showUpdateDialog: canUpdate
        }
    }
}
